import Contact from "../../views/static/contact.vue"

document.addEventListener('DOMContentLoaded', () => {
    var element = document.getElementById('vue')
    if (element != null) {
        var app = new Vue({
            el: element,
            components: { Contact }
        })
        console.log(app)
    }
});